export default __webpack_public_path__ + "static/media/london_l.19d14e22.jpg";